export enum ActionType {
  setHasShown = 'allTherapistsModalAfterSignUp/setHasShown',
}
